import { Log, LogCategory, Operation as LogOperation } from '@augloop/logging';
import { Model, Inputs, lackingPromiseOrWasmSupport } from './model';
export function createFactory(setUpOnnxReference) {
    const createInferenceServiceOp = new LogOperation({
        operationName: 'CreateOnnxInferenceService',
        success: true,
        resultDescription: ''
    });
    createInferenceServiceOp.start();
    if (lackingPromiseOrWasmSupport(createInferenceServiceOp)) {
        const errMsg = 'Browser lacks necessary support for inference service';
        createInferenceServiceOp.success = false;
        createInferenceServiceOp.resultDescription = errMsg;
        Log.info(0x2035f413 /* tag_6n5qt */, LogCategory.CoreDefault, createInferenceServiceOp.stop());
        return Promise.reject(new Error(errMsg));
    }
    else {
        return setUpOnnxReference().then((msg) => {
            createInferenceServiceOp.resultDescription = msg;
            Log.info(0x2035f414 /* tag_6n5qu */, LogCategory.CoreDefault, createInferenceServiceOp.stop());
        }).catch((err) => {
            createInferenceServiceOp.success = false;
            createInferenceServiceOp.resultDescription = err.message;
            Log.info(0x2035f415 /* tag_6n5qv */, LogCategory.CoreDefault, createInferenceServiceOp.stop());
            throw err;
        });
    }
}
/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function createModel(modelUrl, modelName, onnxObject) {
    return Model.create(modelUrl, modelName, onnxObject);
}
export function createInputs() {
    return Inputs.create();
}
//# sourceMappingURL=onnxInferenceServiceBasicMethods.js.map